import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Badge, Form, FormInput } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import { Store } from "../flux";

import Logo from "../images/mainlogo.png";

const Login = (props) => {

    const [ User, SetUser ] = useState("");
    const [ Pass, SetPass ] = useState("");

    useEffect(() => {

        if (props.location && props.location.pathname === "/logout/confirm") {

            Store.setLoggedIn(false);
            localStorage.removeItem("TMOB_LOGGEDIN");
            localStorage.removeItem("TMOB_LOGIN");

            window.location.href = "/";
        }
    }, [ props.location ])

    const login = async () => {

        props.LoginUser(User, Pass);
    }

    return (
        <Container fluid className="main-content-container px-4">
            <br /> <br />
            <Row className="justify-content-center" noGutters>
                <Col lg="4" md="8" sm="12" className="mb-4">
                    <Card small className="card-post card-post--1 justify-content-center" style={{ height: "", cursor: "pointer" }}>
                        <CardBody>
                            <div className="d-table m-auto">
                                <img id="main-logo" className="d-inline-block align-top mr-1" style={{ maxWidth: "25px" }} src={ Logo } alt="Tascomi Mobile" />
                                <span className="d-none d-md-inline ml-1">Tascomi Mobile</span>
                            </div>

                            <br /><br />

                            <Form>
								<Row form className="justify-content-center">

									{/* Username */}
									<Col md="6" className="form-group">
										<label htmlFor="username">Username</label>
										<FormInput autoComplete="no-password" id="username" value={ User } onChange={ (e) => SetUser(e.target.value) } placeholder="Username" />
									</Col>
                                </Row>

                                <Row form className="justify-content-center">
                                    {/* Password */}
									<Col md="6" className="form-group">
										<label htmlFor="password">Password</label>
										<FormInput autoComplete="no-password" type="password" value={ Pass } onChange={ (e) => SetPass(e.target.value) } id="password" placeholder="Password" />
									</Col>
                                </Row>

                                <Row form className="justify-content-center">
                                    <Col md="6" className="form-group">
                                        <Button className="accent-primary" onClick={ login }>Login</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;
